export enum Role {
  root = "root",
  assessor = "assessor",
  manager = "manager",
  provider = "provider",
  kindergarten = "kindergarten",
  department = "department",
}

export enum RoleId {
  Root = 1,
  Assessor = 2,
  Manager = 3,
  Provider = 4,
  Kindergarten = 5,
  Department = 6,
}

// Roles ordered least to most authorised
export const RoleAuthorityOrder = [RoleId.Kindergarten, RoleId.Provider, RoleId.Department, RoleId.Assessor, RoleId.Manager, RoleId.Root];

// RoleId with least authority
export const LowestAuthorityRoleId: RoleId = RoleAuthorityOrder[0]!;

// RoleId with most authority
export const HighestAuthorityRoleId: RoleId = RoleAuthorityOrder.at(-1)!;

// RoleOrder as dict with indices as values
export const RoleAuthority: Record<RoleId, number> = Object.fromEntries(RoleAuthorityOrder.map((item, idx) => [item, idx])) as Record<RoleId, number>;

// True if not null or undefined, and in RoleId
function isValidRole(role: RoleId | null | undefined): boolean {
  return role != null && role in RoleId;
}

// Check if roleA can manage roleB
export function canRoleAManageRoleB(roleA: RoleId | null | undefined, roleB: RoleId | null | undefined): boolean {
  const roleASafe = isValidRole(roleA) ? roleA : LowestAuthorityRoleId; // If invalid/unknown role, cannot manage anyone.
  const roleBSafe = isValidRole(roleB) ? roleB : LowestAuthorityRoleId; // If invalid/unknown role, can be managed.

  const isRoleBAboveRoleA = RoleAuthority[roleBSafe!] > RoleAuthority[roleASafe!];
  return !isRoleBAboveRoleA;
}
